module.exports = __webpack_public_path__ + "img/slider.0979faea.png";